import React, { Fragment, useState } from 'react';
import "../../styles/loading.scss"

const LoadingAnimation = (props) => (
  <Fragment >
    <div className={props.loaderClass} />
  </Fragment>
);      

export default LoadingAnimation;